import { ErrorableLoader } from '@bordrio/ui-components';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router';
import { useFiscalRepresentationByIdQuery } from '@src/generated/graphql';
import OrderLayout from '../../components/OrderLayout';
import { RequestCancellationForm } from './RequestCancellationForm';

export function FiscalRepRequestCancellationPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const { data, error } = useFiscalRepresentationByIdQuery({
    variables: { id: id || '' },
  });
  const { t } = useTranslation('fiscal_rep');
  const navigate = useNavigate();

  if (!data) {
    return <ErrorableLoader error={error} />;
  }

  const { fiscalRepSubscription } = data;

  const cancellationRequest = fiscalRepSubscription.cancellationRequests.find(
    (c) => !c.isComplete,
  );

  if (
    !fiscalRepSubscription.isActive ||
    (cancellationRequest &&
      cancellationRequest?.proofOfCancellationDocument?.status !== 'REJECTED')
  ) {
    return <Navigate to="/" />;
  }

  return (
    <Routes>
      <Route
        element={
          <OrderLayout
            title={t(
              'request_cancellation.title',
              'Cancel Fiscal Representation for {{name}}',
              {
                name: `${fiscalRepSubscription.givenNames} ${fiscalRepSubscription.surname}`,
              },
            )}
            steps={[
              {
                name: t(
                  'request_cancellation.upload_step',
                  'Upload Proof of Cancellation',
                ),
                href: '#',
                status: 'current',
              },
            ]}
            onExitClick={() => navigate('/')}
          />
        }
      >
        <Route
          index
          element={
            <RequestCancellationForm subscription={fiscalRepSubscription} />
          }
        />
      </Route>
    </Routes>
  );
}
